import React, { useContext } from 'react';
import {
  Store,
  updateDivision,
  updateSelectedTickets,
  updateModalResponseType,
  toggleNotesAndPhotosModal,
  toggleMoveModal,
  toggleRespondModal,
  toggleReopenModal,
} from '../../../../store';
import { checkForRequiredPermissions } from '../../../../utils/helpers';
import './style.scss';

const SingleTicketActions = () => {
  const { state, dispatch } = useContext(Store);
  const { ticketDetail } = state;

  if (!ticketDetail) {
    return null;
  }

  const {
    _id,
    id,
    doc_type,
    pge_division,
    pge_status,
    field_meet_scheduled_date,
    standby_scheduled_date,
  } = ticketDetail;

  const ticketId = _id || id;

  const addNotesAndPhotos = () => {
    updateModalResponseType('notesAndPhotos', dispatch);
    toggleNotesAndPhotosModal(true, dispatch);
    updateSelectedTickets([ticketId], dispatch);
  };
  const moveTicket = () => {
    const divisionString = pge_division || 'Unknown';
    const division = { value: divisionString, label: divisionString };
    updateDivision(division, dispatch);
    updateSelectedTickets([ticketId], dispatch);
    toggleMoveModal(true, dispatch);
  };

  const respondToTicket = responseType => {
    updateModalResponseType(responseType, dispatch);
    updateSelectedTickets([ticketId], dispatch);
    toggleRespondModal(true, dispatch);
  };
  const reopenTicket = () => {
    updateSelectedTickets([ticketId], dispatch);
    toggleReopenModal(true, dispatch);
  };

  let respondButtonText;
  if (doc_type === 'ticket') {
    respondButtonText = 'Respond';
  } else {
    respondButtonText = field_meet_scheduled_date || standby_scheduled_date ? 'Update' : 'Schedule';
  }

  return (
    <div className={'ticket-actions'}>
      <div className={'button-container'}>
        {pge_status?.toUpperCase() === 'CLOSED' ? (
          <React.Fragment>
            {checkForRequiredPermissions('SUPERVISOR_REOPEN_TICKET') && (
              <button type="button" onClick={() => reopenTicket()}>
                Reopen
              </button>
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {checkForRequiredPermissions('SUPERVISOR_MOVE_TICKET') && (
              <button type="button" onClick={() => moveTicket()}>
                Move
              </button>
            )}
            {checkForRequiredPermissions('SUPERVISOR_RESPOND_TICKET') && (
              <button type="button" onClick={() => respondToTicket('scheduleStandby')}>
                {respondButtonText}
              </button>
            )}
            {checkForRequiredPermissions('SUPERVISOR_RESPOND_TICKET') &&
              doc_type === 'standby' &&
              !standby_scheduled_date && (
                <button type="button" onClick={() => respondToTicket('closeStandby')}>
                  Close
                </button>
              )}
          </React.Fragment>
        )}
        {checkForRequiredPermissions('SUPERVISOR_NOTES_AND_PHOTOS') && (
          <button type="button" onClick={() => addNotesAndPhotos()}>
            Notes&Photos
          </button>
        )}
      </div>
    </div>
  );
};

export default SingleTicketActions;
